import * as _4 from 'lodash4';
export class InTakeSurveyAnswer {
  readonly id: number;
  value: string;
  question_id: number;
  resources: number[]; // we don't need or using this attr in poll

  constructor(inTakeSurveyAnswer: Partial<InTakeSurveyAnswer>) {
    _4.merge(this, inTakeSurveyAnswer);
  }

  static build(inTakeSurveyPoll: Partial<InTakeSurveyAnswer>): InTakeSurveyAnswer {
    return new InTakeSurveyAnswer(inTakeSurveyPoll);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/builders/ap_intake_survey_answer_builder.ts